module.exports = __webpack_public_path__ + "assets/img/zh-Hant-281a2f36.png";